export default __webpack_public_path__ + "static/media/storm-1.9d642ba8.png";